import React from "react";
import { NavLink } from "react-router-dom";
import { UseUserAuth } from "./context/UseAuthContext";

const foliageCSS = `
.mtm-section {
  position: relative;
  overflow: hidden;
  background: #F0EEFF;
}
@media (max-width: 960px) {
  .mtm-section { background: transparent; }
  .mtm-inner-wrap { background: #F0EEFF; overflow: hidden; }
}
.mtm-foliage {
  position: absolute; left: 0; right: 0; bottom: 0; width: 100%; pointer-events: none; z-index: 0;
}
.mtm-foliage svg { width: 100%; height: auto; display: block; }
@media (max-width: 960px) {
  .mtm-section { padding-bottom: 0 !important; }
  .mtm-foliage { position: relative; bottom: auto; margin-top: -40px; }
  .mtm-inner-wrap { padding-bottom: 0 !important; }
}
.mtm-accent {
  position: relative; display: inline-block;
  color: #4F46E5; font-style: italic;
  font-family: Georgia, serif;
}
.mtm-underline {
  position: absolute; left: -2%; right: -2%; bottom: 2px;
  height: 11px; background: #FFD66B; opacity: .5;
  border-radius: 20px; z-index: -1; transform-origin: left;
  animation: mtm-drawLine 1.4s ease-out .3s both;
}
@keyframes mtm-drawLine { from{transform:scaleX(0)} to{transform:scaleX(1)} }
`;

const Foliage = () => (
  <div className="mtm-foliage">
    <svg viewBox="0 0 1440 200" preserveAspectRatio="none" aria-hidden="true">
      <path d="M0 140 Q200 80 400 120 T800 120 T1200 115 T1440 135 L1440 200 L0 200 Z" fill="#C6E3B3" opacity=".5" />
      <path d="M0 165 Q180 130 360 155 T720 155 T1080 150 T1440 165 L1440 200 L0 200 Z" fill="#9FCB8E" opacity=".7" />
      <path d="M0 182 Q720 168 1440 182 L1440 200 L0 200 Z" fill="#6BA37A" />
    </svg>
  </div>
);

function Display() {
  const { user } = UseUserAuth();

  return (
    <main>
      <style>{foliageCSS}</style>
      <div className="mtm-section">
        <div
          className="relative isolate overflow-hidden bg-gradient-to-b from-indigo-100/20 pt-4 mtm-inner-wrap"
          style={{ paddingBottom: "180px" }}
        >
          <div className="mx-auto max-w-7xl px-6 py-12 sm:py-16 lg:px-8">
            <div className="mx-auto max-w-2xl lg:mx-0 lg:grid lg:max-w-none lg:grid-cols-2 lg:gap-x-12 xl:gap-x-16">

              <div className="lg:col-span-1">
                <div className="inline-flex items-center bg-indigo-600 text-white px-4 py-2 rounded-full text-sm font-medium">
                  ⭐ Create Hyper-Personalized Children's Stories
                </div>

                <h1 className="mt-4 text-4xl font-bold tracking-tight text-gray-900 sm:text-5xl">
                  Every Child Is{" "}
                  <span className="mtm-accent">Unique.<span className="mtm-underline" /></span>
                  <br />
                  Their Story Should Be{" "}
                  <span className="mtm-accent">Too.<span className="mtm-underline" /></span>
                </h1>

                <p className="mt-4 text-lg text-gray-600">
                  MyTaleMaker builds the story around your child — their name, their face, their little quirks.
                  Not swap-a-name templates. Real collaboration: you guide, our AI illustrates the magic.
                </p>

                <div className="mt-6 space-y-3">
                  <div className="flex items-center gap-x-2">
                    <span className="text-indigo-600">✓</span>
                    <span>First personalized story completely free - No credit card needed</span>
                  </div>
                  <div className="flex items-center gap-x-2">
                    <span className="text-indigo-600">✓</span>
                    <span>Upload a photo or pick avatar traits — characters <em>actually look like them</em>.</span>
                  </div>
                  <div className="flex items-center gap-x-2">
                    <span className="text-indigo-600">✓</span>
                    <span>Download as PDF or read online instantly</span>
                  </div>
                  <div className="flex items-center gap-x-2">
                    <span className="text-indigo-600">✓</span>
                    <span>Order beautiful print books as keepsakes</span>
                  </div>
                </div>

                <div className="mt-8 flex items-center gap-x-4" style={{ position: "relative", zIndex: 1 }}>
                  <NavLink
                    to={user ? '/create' : "/signup"}
                    className="rounded-md bg-indigo-600 px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                  >
                    Start Your Free Story
                  </NavLink>
                  <NavLink
                    to="/gallery"
                    className="text-sm font-semibold leading-6 text-gray-900"
                  >
                    See Examples <span aria-hidden="true">→</span>
                  </NavLink>
                </div>
              </div>

              <div className="mt-8 lg:mt-0">
                <img
                  src="https://static.mytalemaker.com/mom-son-printbook3.webp"
                  alt="Happy family creating a personalized story together on MyTaleMaker"
                  className="w-full rounded-2xl object-cover shadow-xl"
                  width="1024"
                  height="1024"
                  loading="lazy"
                  fetchpriority="high"
                />
              </div>
            </div>
          </div>

          <Foliage />
        </div>
      </div>
    </main>
  );
}

export default Display;